<div [hidden]="Show_History_View>0" class="card card-statistics mb-30">
  <div class="card-body">
    <h5 class="card-title">Calibration Request Form</h5>


    <div>

      <form>
        <div class="row">
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> Letter Number </label>
            <input type="text" class="form-control" disabled value="{{Letter_Form_Code}}" />
          </div>
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1">Behfa Customer Code </label>
            <input type="text" class="form-control" disabled value="{{Data_Seleted_Customer.code}}" />
          </div>
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1">Customer Name </label>
            <input type="text" class="form-control" disabled value="{{Data_Seleted_Customer.name}}" />
          </div>
        </div>
      </form>

      <br />
      <hr />
      <br />

      <form [formGroup]="AddNewLetter">

        <div class="row">

          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> Sender Salutation </label>
            <select class="custom-select" formControlName="sex">
              <option value="0">Ms.</option>
              <option value="1" selected>Mr.</option>
            </select>
          </div>
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> Sender Name </label>
            <input formControlName="giver_name" type="text" class="form-control" placeholder="Type here...">
            <small *ngIf="!get_Form_giver_name().valid && get_Form_giver_name().touched"
              class="form-text text-muted MyErrorRedColor">Enter the sender name.</small>
          </div>
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> Sender Position </label>
            <input formControlName="giver_semat" type="text" class="form-control" placeholder="Type here...">
            <small *ngIf="!get_Form_giver_semat().valid && get_Form_giver_semat().touched"
              class="form-text text-muted MyErrorRedColor">Enter the sender position.</small>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1"> Referenced Letter Number </label>
            <input formControlName="bazgashtBeNamehShomareh" type="text" class="form-control"
              placeholder="Type here...">
            <small *ngIf="!get_Form_bazgashtBeNamehShomareh().valid && get_Form_bazgashtBeNamehShomareh().touched"
              class="form-text text-muted MyErrorRedColor">Enter the referenced letter number.</small>
          </div>

          <div class="form-group col-md-6" *ngIf="Letter_Form_Id==0 || !Letter_Form_Id">
            <label for="exampleInputEmail1"> Referenced Letter Date </label>
            <input formControlName="bazgashtBeNamehTarikh" type="text" class="form-control"
              #datepickerbazgashtBeNamehTarikh placeholder="Type here...">
            <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false"
              [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerbazgashtBeNamehTarikh"></ng-persian-datepicker>
          </div>

          <div class="form-group col-md-6" *ngIf="Letter_Form_Id>0">
            <label for="exampleInputEmail1"> Referenced Letter Date </label>
            <input formControlName="bazgashtBeNamehTarikh" disabled type="text" class="form-control"
              placeholder="Type here...">
          </div>
        </div>


      </form>



      <br />
      <hr />
      <br />

      <h5> Equipment </h5>

      <br />
      <br />
      <form *ngIf="canEditMainForm" [formGroup]="DeviceForm" (submit)="DeviceForm_Submit()">

        <input type="hidden" formControlName="id" />

        <div class="row">
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1"><button type="button" (click)="openModal_Device(templateDevice)"
                class="btn btn-warning left"> Select Instrument (English Name) <i class="fa fa-cc-amex"></i> </button> </label>
            <input type="text" class="form-control" disabled value="{{Data_Seleted_Device_Record.title}}" />
          </div>
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1"> Persian Title </label>
            <select class="custom-select" formControlName="device_id">
              <option value="0">Select</option>
              <option *ngFor="let item of DataList_Devicepersian" [value]="item.id">{{item.dsc}}</option>
            </select>
          </div>


        </div>

        <div class="row">
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> Calibration Location </label>
            <select class="custom-select" formControlName="location">
              <option value="0">Select</option>
              <option value="1">Customer Site</option>
              <option value="2">Behineh Laboratory</option>
            </select>
          </div>
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1">Count</label>
            <input formControlName="tedad" type="number" class="form-control" placeholder="Type here...">
            <small *ngIf="!get_DeviceForm_tedad().valid && get_DeviceForm_tedad().touched"
              class="form-text text-muted MyErrorRedColor">Enter the quantity.</small>
          </div>

          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> Validity Period </label>
            <select formControlName="Expiration" class="custom-select">
              <option value="0">Select</option>
              <option *ngFor="let item of Data_List_Expiration" [value]="item.id">{{item.title}}</option>
            </select>
          </div>
        </div>


        <div class="row" *ngIf="Data_Seleted_Device_Record.title">
          <br />
          <div class="table-responsive">
            <table class="mb-0 table table-bordered table-3 text-center table-striped">
              <thead style="background-color: #39409b; color: white;">
                <tr>
                  <th>#</th>
                  <th>Note</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of DataList_Tariff">
                  <td>{{DataList_Tariff.indexOf(item)+1}}</td>
                  <td style="text-align: left;">{{item.dsc}}</td>

                  <td>
                    <label *ngIf="selected_Tariff_Record.id!=item.id" for="exampleInputEmail1"><button type="button"
                        (click)="set_Selected_Tariff(item)" class="btn btn-danger left"> Select </button> </label>
                    <p *ngIf="selected_Tariff_Record.id==item.id" style="color: red;">Note Selected</p>
                  </td>

                </tr>
              </tbody>
            </table>
          </div>

        </div>



        <div class="row">

          <div class="form-group col-md-12">
            <label for="exampleInputEmail1"> Description </label>
            <textarea type="text" placeholder="Type here..." formControlName="dsc"
              class="form-control"></textarea>
          </div>

        </div>

        <button type="submit" [disabled]="!DeviceForm.valid" class="btn btn-success" style="margin-right: 5px;"><i
            class="fa  fa-plus-circle"></i> Add Equipment </button>
      </form>


      <br />
      <br />

      <div class="table-responsive" *ngIf="DeviceFormList.length>0">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>Instrument English Name</th>
              <th>Instrument Persian Name</th>
              <th>Calibration Location</th>
              <th>Validity Period</th>
              <th>Count</th>
              <th>Remarks</th>
              <th>Description</th>
              <th>User</th>
              <th>Date</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DeviceFormList">
              <td>{{DeviceFormList.indexOf(item)+1}}</td>
              <td>{{item.device_name_en}}</td>
              <td>{{item.device_name}}</td>
              <td>{{item.location_name === 'محل مشتری' ? 'Customer Site' : item.location_name === 'آزمایشگاه بهینه' ? 'Behineh Laboratory' : item.location_name}}</td>
              <td>{{item.expiration_title}}</td>
              <td>{{item.tedad}}</td>
              <td>{{item.price_dsc}}</td>
              <td>{{item.dsc}}</td>
              <td>{{item.username}}</td>
              <td>{{item.persianDate}}</td>
              <td *ngIf="canEditMainForm">
                <div *ngIf="!item.del" class="btn-group  " role="group" aria-label="Button group with nested dropdown">
                  <div class="btn-group" role="group">
                    <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle"
                      data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      Actions
                    </button>
                    <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                      <a style="cursor: pointer;"
                        (click)="DeleteDeviceFormList_Modal(templateRemoveDevice,DeviceFormList.indexOf(item))"
                        class="dropdown-item"><i class="fa fa-remove"></i> Delete </a>
                    </div>
                  </div>
                </div>
                <p *ngIf="item.del">Deleted</p>
              </td>
              <td *ngIf="!canEditMainForm">
                <p *ngIf="item.del">Deleted</p>
              </td>
            </tr>

          </tbody>
        </table>
      </div>

      <br />
      <hr />
      <br />


      <div *ngIf="canEditMainForm" class="row">
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">
            Attachments
            <button (click)="Remove_uploadImage1()" type="button" *ngIf="UploadImageSrc" class="btn  btn-danger"><i
                class="fa  fa-times-rectangle"></i> </button>
          </label>
          <img *ngIf="InProccessing_Image1" src="assets/Loading.gif" style="width: 25px;" />
          <input *ngIf="!InProccessing_Image1" #file_Image1 (change)="uploadImage1(file_Image1.files)" type="file"
            class="form-control" placeholder="Type here...">
        </div>
      </div>

      <button *ngIf="canEditMainForm" type="button" (click)="Add_uploadImage1()" [disabled]="!UploadImageSrc"
        class="btn btn-info" style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Add Attachment </button>

      <br />

      <div class="table-responsive" *ngIf="UploadImageSrc_List.length>0">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>File</th>

              <th *ngIf="canEditMainForm">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of UploadImageSrc_List">

              <td>{{UploadImageSrc_List.indexOf(item)+1}}</td>
              <td>

                <a target="_blank" *ngIf="item.title.includes('.pdf')" href="{{BaseUrl}}File/Letter/{{item.title}}"
                  class="btn btn-success"><i class="fa fa-file-pdf-o"></i> PDF </a>


                <img *ngIf="!item.title.includes('.pdf')" (click)="openModal(templateImage,item.title)"
                  style="width: 150px;cursor: zoom-in;" src="{{BaseUrl}}File/Letter/{{item.title}}" />
              </td>
              <td *ngIf="canEditMainForm">
                <div class="btn-group  " role="group" aria-label="Button group with nested dropdown">
                  <div class="btn-group" role="group">
                    <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle"
                      data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      Actions
                    </button>
                    <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                      <a style="cursor: pointer;"
                        (click)="UploadImageSrc_List_Delete(UploadImageSrc_List.indexOf(item))" class="dropdown-item"><i
                          class="fa fa-remove"></i> Delete </a>
                    </div>
                  </div>
                </div>
              </td>

            </tr>
          </tbody>
        </table>
      </div>


    </div>


    <br />
    <br />

    <img *ngIf="Data_Seleted_Customer.id>0 && InProccessing" src="assets/Loading.gif" style="width: 25px;" />
    <button *ngIf="Letter_Form_Id>0 && !InProccessing" (click)="ReadHistory_Letter()" type="button"
      class="btn btn-warning" style="margin-right: 5px;"> <i class="fa fa-file-text"></i> Letter Details </button>
    <ng-container *ngFor="let item of Data_List_Order">

      <button *ngIf="item.submit && !InProccessing" [disabled]="!AddNewLetter.valid" type="button"
        (click)="OpenOrderDialog(templateOrder,item)" [class]="item.cls" style="margin-right: 5px;"> <i
          [class]="item.icon"></i> {{item.title}} </button>

      <button *ngIf="!item.hasRefer && !item.submit && !item.copy && !InProccessing" type="button"
        (click)="OpenOrderDialog(templateOrder,item)" [class]="item.cls" style="margin-right: 5px;"> <i
          [class]="item.icon"></i> {{item.title}} </button>


    </ng-container>
    <img *ngIf="OpenOrderDialog_Loading" src="assets/Loading.gif" style="width: 25px;" />


    <br />
    <br />



  </div>



</div>


<div *ngIf="Show_History_View==1" class="card card-statistics mb-30">

  <div class="card-body">
    <div class="tab nav-border" style="position: relative;">
      <div class="d-block d-md-flex justify-content-between">
        <div class="d-block w-100">
          <h5 class="card-title border-0 pb-0">Letter Details '{{Letter_Form_Code}}'</h5>
        </div>
        <div class="d-block d-md-flex nav-tabs-custom">
          <ul class="nav nav-tabs" id="myTab" role="tablist">
            <li class="nav-item">
              <a class="nav-link active show" id="months-tab" data-toggle="tab" href="#order" role="tab"
                aria-controls="months" aria-selected="true">Referral History</a>
            </li>

          </ul>
        </div>
      </div>
      <div class="tab-content" id="myTabContent">

        <div class="tab-pane fade active show" id="order" role="tabpanel" aria-labelledby="months-tab">
          <div class="row mb-30">
            <app-LetterRequestCustomerHistory [DataList_History]="DataList_History"></app-LetterRequestCustomerHistory>
          </div>
          <button *ngIf="!InProccessing && canDeleteHistoryRecord && DataList_Peyvast.length==1" type="button" (click)="DeleteLetterHistoryRecord()" class="btn btn-danger"><i class="fa fa-remove"></i>Delete Latest Referral</button>
        </div>

      </div>
    </div>
  </div>


  <div class="card-body">
    <button (click)="Close_Show_History()" type="button" class="btn btn-warning" style="margin-right: 5px;"> Back
    </button>
  </div>

</div>


<ng-template #templateDevice>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Instrument Information List </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Device.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="card-body">
      <div class="row">
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1"> Instrument Name (English Name) </label>
          <input type="text" class="form-control" (keyup)="ReadData_Device_KeySearch()"
            [(ngModel)]="Search_Name_Device_Table" placeholder="Type here to search...">
        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>Instrument Name</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_Device">
              <td>{{DataList_Device.indexOf(item)+1}}</td>
              <td>{{item.title}}</td>
              <td (click)="Set_Selected_Device_Record(item)" style="cursor: pointer;">
                <button class="btn btn-info"><i class="fa fa-check"></i> Select</button>
              </td>

            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <img *ngIf="ProcssingDevice" src="assets/Loading.gif" style="width: 25px;" />
    <button *ngIf="!ProcssingDevice" type="button" (click)="ReadData_Device()" class="btn btn-info"
      style="margin-right: 5px;"><i class="fa  fa-search"></i> Search </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_Device.hide()">Close</button>
  </div>
</ng-template>

<ng-template #templateOrder>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> {{Selected_Order_Operation.title}} </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Order.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="form-group col-md-12">
        <label for="exampleInputEmail1">Description</label>
        <input type="text" class="form-control" [(ngModel)]="LetterHistoryDsc" placeholder="Type here...">
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-success"
      (click)="SubmitAddNewLetter_Co(templateCode,Selected_Order_Operation)"> Submit and Register </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_Order.hide()">Close</button>
  </div>
</ng-template>

<ng-template #templateCode>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> Calibration Request </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Code.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <p>Calibration Request Number <b>'{{Letter_Form_Code}}'</b> was registered successfully. </p>
  </div>
  <div class="modal-footer">

    <button type="button" class="btn btn-danger" (click)="modalRef_Code.hide()">Close</button>
  </div>
</ng-template>

<ng-template #templateRemoveDevice>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Approve Delete Instrument '{{DeleteDeviceFormList_Record.device_name}}' </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_DeleteDeviceFormList.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-warning" (click)="DeleteDeviceFormList()"> Delete Instrument <i
        class="fa fa-remove"></i></button>
    <button type="button" class="btn btn-danger" (click)="modalRef_DeleteDeviceFormList.hide()">Close</button>
  </div>
</ng-template>

<ng-template #templateImage>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> View Image </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Image.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body" style="text-align: center;">
    <img style="max-width: 350px;" src="{{BaseUrl}}File/Letter/{{ModalimageUrl}}" />
  </div>
  <div class="modal-footer">
    <a class="dropdown-item" target="_blank" href="{{BaseUrl}}File/Letter/{{ModalimageUrl}}"><i
        class="fa fa-download"></i> Download </a>
    <button type="button" class="btn btn-danger" (click)="modalRef_Image.hide()">Close</button>
  </div>
</ng-template>
